<script setup>
import { levelEnum } from "@/utilities/enum";
</script>
<template>
  <v-navigation-drawer v-model="sidebarStore.drawer" app :temporary="isMobile" mobile-breakpoint="600"
    class="sidebar relative transition-all duration-500 ease-in-out pt-5" :width="240" style="z-index: 1004">
    <div class="flex flex-col mt-4">
      <div class="absolute top-5 cursor-pointer transition-all duration-700 ease-in-out transform-gpu"
        @click="sidebarStore.toggleDrawer()" :class="{ '-right-10': !sidebarStore.drawer }">
        <img src="../assets/icon/arrow.svg" alt="icon-arrow"
          class="p-1 rounded-lg w-7 ml-3 bg-slate-800 transition-transform duration-700 ease-in-out transform-gpu"
          :class="{ 'rotate-180': !sidebarStore.drawer }" />
      </div>

      <v-list class="flex flex-col mt-5 p-0">
        <v-list-item class="items-start pl-5 relative group" v-for="(menu, index) in menus" :key="index">
          <div class="flex justify-between items-center cursor-pointer"
            @click="menu.subs.length ? showSub(menu) : $router.push(menu.path)">
            <div>
              <div :class="[
                isParentActive(
                  menu.subs.length > 0
                    ? menu.subs
                      .filter((item) => item.path)
                      .map((item) => item.path)
                    : [menu.path],
                )
                  ? 'block'
                  : 'hidden group-hover:block',
              ]" class="absolute w-1 left-0 bg-red-600 h-full rounded-br-lg rounded-tr-lg top-0"></div>
              <div class="flex gap-3 items-center py-3">
                <img :src="[
                  isParentActive(
                    menu.subs.length > 0
                      ? menu.subs
                        .filter((item) => item.path)
                        .map((item) => item.path)
                      : [menu.path],
                  )
                    ? require(`@/assets/icons/${menu.iconActive}`)
                    : require(`@/assets/icons/${menu.iconInactive}`),
                ]" alt="icon" class="w-5 h-auto" />
                <a class="text-sm font-medium text-slate-600" :class="[
                  isParentActive(
                    menu.subs.length > 0
                      ? menu.subs
                        .filter((item) => item.path)
                        .map((item) => item.path)
                      : [menu.path],
                  )
                    ? 'text-red-600'
                    : 'group-hover:text-red-600',
                ]">
                  {{ menu.title }}
                </a>
              </div>
            </div>
            <img v-if="menu.subs.length" src="../assets/icons/arrow.png" alt="arrow" loading="lazy"
              class="w-2 h-auto mr-1 duration-200 ease-in" :class="{ 'rotate-90': menu.showSub }" />
          </div>
          <ul class="ml-2 overflow-hidden transition-all duration-300 ease-in-out" :class="[
            menu.showSub ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0',
          ]">
            <li class="items-start" v-for="(item, key) in menu.subs" :key="key">
              <router-link :to="item.path" v-slot="{ href, isActive }">
                <a :href="href" @click="$router.push(item.path)" class="text-xs py-3 font-medium block cursor-pointer"
                  :class="[isActive ? 'text-red-600' : 'hover:text-red-600']">
                  <i class="fas fa-calendar-alt mr-2 text-red-600"></i>
                  {{ item.title }}
                </a>
              </router-link>
            </li>
          </ul>
        </v-list-item>
      </v-list>
    </div>
  </v-navigation-drawer>
</template>

<script>
import GlobalDataMixin from "@/GlobalDataMixin";
import { useSidebarStore } from "@/stores/sidebar";

export default {
  mixins: [GlobalDataMixin],
  name: "SidebarLayout",
  data() {
    return {
      sidebarStore: useSidebarStore(),
      isMobile: false,
      role: null,
      menus: [
        {
          id: 1,
          title: "Dashboard",
          iconActive: "dashboard.png",
          iconInactive: "dashboard.png",
          path: "/dashboard",
          subs: [],
          showSub: false,
          access: [
            levelEnum.ADMIN,
            levelEnum.KONTRAKTOR,
            levelEnum.REPORTER,
            levelEnum.ENVIRONMENT,
            levelEnum.OHS,
            levelEnum.ISAFE,
          ],
        },
        {
          id: 2,
          title: "Dashboard ESG",
          iconActive: "dashboard.png",
          iconInactive: "dashboard.png",
          path: "/dashboard-esg",
          subs: [],
          showSub: false,
          access: [levelEnum.ENVIRONMENT, levelEnum.IMPROVEMENT],
        },
        {
          id: 2,
          title: "Dashboard NC",
          iconActive: "dashboard.png",
          iconInactive: "dashboard.png",
          path: "/dashboard-nc",
          subs: [],
          showSub: false,
          access: [levelEnum.ADMIN],
        },
        {
          id: 3,
          title: "Profile Perusahaan",
          iconActive: "buildings.png",
          iconInactive: "buildings.png",
          path: "/profile",
          subs: [],
          showSub: false,
          access: [levelEnum.KONTRAKTOR],
        },
        {
          id: 4,
          title: "Kontrak",
          iconActive: "file.png",
          iconInactive: "file.png",
          path: "/kontrak",
          subs: [],
          showSub: false,
          access: [levelEnum.KONTRAKTOR],
        },
        {
          id: 5,
          title: "CoC",
          iconActive: "notes.png",
          iconInactive: "notes.png",
          path: "/sio",
          subs: [],
          showSub: false,
          access: [levelEnum.KONTRAKTOR],
        },
        {
          id: 6,
          title: "Penilaian PJO",
          iconActive: "folder.png",
          iconInactive: "folder.png",
          path: "#",
          subs: [
            {
              id: 1,
              title: "NC Presentasi PJO",
              path: "/penilaian-pjo/nc-presentasi",
              access: [levelEnum.KONTRAKTOR],
            },
          ],
          showSub: false,
        },
        {
          id: 7,
          title: "Master Data",
          iconActive: "master.png",
          iconInactive: "master.png",
          path: "#",
          subs: [
            {
              id: 1,
              title: "User Kontraktor",
              path: "/master-data/user-contractor",
              access: [levelEnum.ADMIN],
            },
            {
              id: 2,
              title: "User Internal",
              path: "/master-data/user-internal",
              access: [levelEnum.ADMIN],
            },
            {
              id: 3,
              title: "User External",
              path: "/master-data/user-external",
              access: [levelEnum.ADMIN],
            },
            {
              id: 4,
              title: "Kontraktor",
              path: "/manajement/kontraktor",
              access: [levelEnum.ADMIN],
            },
            {
              id: 5,
              title: "Kontrak",
              path: "/kontrak",
              access: [levelEnum.ADMIN],
            },
            {
              id: 6,
              title: "Fuel",
              path: "/master-data/type/fuel",
              access: [levelEnum.ENVIRONMENT],
            },
            {
              id: 7,
              title: "Electrification",
              path: "/master-data/type/elektrifikasi",
              access: [levelEnum.ENVIRONMENT],
            },
            {
              id: 8,
              title: "Renewable Energy",
              path: "/master-data/type/renewable",
              access: [levelEnum.ENVIRONMENT],
            },
            {
              id: 9,
              title: "Available Power",
              path: "/master-data/power-available",
              access: [levelEnum.ENVIRONMENT],
            },
            {
              id: 10,
              title: "Klasifikasi NC",
              path: "/master-data/classification",
              access: [levelEnum.ADMIN],
            },
            {
              id: 11,
              title: "Elemen NC",
              path: "/master-data/element",
              access: [levelEnum.ADMIN],
            },
            {
              id: 12,
              title: "Aspek Evaluasi NC",
              path: "/master-data/aspect-evaluation",
              access: [levelEnum.ADMIN],
            },
            {
              id: 13,
              title: "Aspek Evaluasi Detail",
              path: "/master-data/aspect-evaluation-detail",
              access: [levelEnum.ADMIN],
            },
            {
              id: 14,
              title: "Aspek Evaluasi Pinalti",
              path: "/master-data/aspect-evaluation-pinalty",
              access: [levelEnum.ADMIN],
            },
            {
              id: 15,
              title: "Klausul NC",
              path: "/master-data/clause",
              access: [levelEnum.ADMIN],
            },
            /*
            {
              id: 16,
              title: "Kategori",
              path: "/improvement-tracker/master/categories",
              // TC-SS-Master-14: Tim CI (stand-in role "improvement") atau Admin, matching
              // MasterDataRoleGuard on the backend and router/index.js's meta.access - Rizky
              // Ramadhan's review comment on !925 ("admin tetep boleh kelola master").
              access: [levelEnum.IMPROVEMENT, levelEnum.ADMIN, levelEnum.CI_TEAM],
            },
            {
              id: 17,
              title: "Tipe Impact",
              path: "/improvement-tracker/master/impact-types",
              access: [levelEnum.IMPROVEMENT, levelEnum.ADMIN, levelEnum.CI_TEAM],
            },
            {
              id: 18,
              title: "Area",
              path: "/improvement-tracker/master/areas",
              access: [levelEnum.IMPROVEMENT, levelEnum.ADMIN, levelEnum.CI_TEAM],
            },
            */
          ],
          showSub: false,
        },
        {
          id: 8,
          title: "Approval CoC",
          iconActive: "coolicon.png",
          iconInactive: "coolicon.png",
          path: "#",
          subs: [
            {
              id: 1,
              title: "Pengajuan Baru",
              path: "/approval-sio",
              access: [
                levelEnum.ADMIN,
                levelEnum.ISAFE,
                levelEnum.ENVIRONMENT,
                levelEnum.IMPROVEMENT,
                levelEnum.OHS,
                levelEnum.REPORTER,
              ],
            },
            {
              id: 2,
              title: "Pergantian PJO",
              path: "/pergantian-sio",
              access: [
                levelEnum.ADMIN,
                levelEnum.ISAFE,
                levelEnum.ENVIRONMENT,
                levelEnum.IMPROVEMENT,
                levelEnum.OHS,
                levelEnum.REPORTER,
              ],
            },
            {
              id: 3,
              title: "Update Data",
              path: "/update-data-sio",
              access: [levelEnum.ADMIN, levelEnum.ISAFE],
            },
          ],
          showSub: false,
        },
        {
          id: 9,
          title: "IMKP",
          iconActive: "notes.png",
          iconInactive: "notes.png",
          path: "/imkp",
          subs: [],
          showSub: false,
          access: [levelEnum.KONTRAKTOR],
        },
        {
          id: 10,
          title: "Approval IMKP",
          iconActive: "window_check.png",
          iconInactive: "window_check.png",
          path: "/approval-imkp",
          subs: [],
          showSub: false,
          access: [levelEnum.OHS, levelEnum.ADMIN, levelEnum.ENVIRONMENT],
        },
        {
          id: 11,
          title: "Report CoC",
          iconActive: "folder.png",
          iconInactive: "folder.png",
          path: "#",
          subs: [
            {
              id: 1,
              title: "Pengajuan Baru",
              path: "/pengajuan-baru-report",
              access: [
                levelEnum.REPORTER,
                levelEnum.OHS,
                levelEnum.ISAFE,
                levelEnum.ENVIRONMENT,
                levelEnum.IMPROVEMENT,
              ],
            },
            {
              id: 2,
              title: "Pergantian PJO",
              path: "/pergantian-sio-report",
              access: [
                levelEnum.REPORTER,
                levelEnum.OHS,
                levelEnum.ISAFE,
                levelEnum.ENVIRONMENT,
                levelEnum.IMPROVEMENT,
              ],
            },
            {
              id: 3,
              title: "Update Data",
              path: "/update-data-report",
              access: [
                levelEnum.REPORTER,
                levelEnum.OHS,
                levelEnum.ISAFE,
                levelEnum.ENVIRONMENT,
                levelEnum.IMPROVEMENT,
              ],
            },
          ],
          showSub: false,
        },
        {
          id: 12,
          title: "Report IMKP",
          iconActive: "file.png",
          iconInactive: "file.png",
          path: "/approval-imkp",
          subs: [],
          showSub: false,
          access: [levelEnum.REPORTER, levelEnum.OHS, levelEnum.ISAFE],
        },
        {
          id: 13,
          title: "Report ESG",
          iconActive: "report-esg.png",
          iconInactive: "report-esg.png",
          path: "/esg-report",
          subs: [],
          showSub: false,
          access: [
            levelEnum.ENVIRONMENT,
            levelEnum.KONTRAKTOR,
            levelEnum.IMPROVEMENT,
          ],
        },
        {
          id: 14,
          title: "Setting",
          iconActive: "datechecklish.png",
          iconInactive: "datechecklish.png",
          path: "/setting",
          subs: [],
          showSub: false,
          access: [levelEnum.ENVIRONMENT],
        },
        /*
        {
          id: 20,
          title: "Manajemen Role & Menu",
          iconActive: "window_check.png",
          iconInactive: "window_check.png",
          path: "#",
          subs: [
            {
              id: 1,
              title: "Manajemen Role",
              path: "/management-rbac/role",
              access: [levelEnum.ADMIN],
            },
            {
              id: 2,
              title: "Manajemen Menu",
              path: "/management-rbac/menu",
              access: [levelEnum.ADMIN],
            },
            {
              id: 3,
              title: "Assign Role User",
              path: "/management-rbac/user-role",
              access: [levelEnum.ADMIN],
            },
          ],
          showSub: false,
          access: [levelEnum.ADMIN],
        },
        {
          id: 21,
          title: "Improvement Tracker",
          iconActive: "folder.png",
          iconInactive: "folder.png",
          path: "#",
          subs: [
            {
              id: 1,
              title: "Dashboard",
              path: "/improvement-tracker/dashboard",
              access: [
                levelEnum.ADMIN,
                levelEnum.OHS,
                levelEnum.REPORTER,
                levelEnum.ENVIRONMENT,
                levelEnum.IMPROVEMENT,
                levelEnum.ISAFE,
                levelEnum.KONTRAKTOR,
                levelEnum.EXTERNAL,
                levelEnum.CI_TEAM,
              ],
            },
            {
              id: 2,
              title: "Daftar Project",
              path: "/improvement-tracker/ideas",
              access: [
                levelEnum.ADMIN,
                levelEnum.OHS,
                levelEnum.REPORTER,
                levelEnum.ENVIRONMENT,
                levelEnum.IMPROVEMENT,
                levelEnum.ISAFE,
                levelEnum.KONTRAKTOR,
                levelEnum.EXTERNAL,
                levelEnum.CI_TEAM,
              ],
            },
          ],
          showSub: false,
          access: [
            levelEnum.ADMIN,
            levelEnum.OHS,
            levelEnum.REPORTER,
            levelEnum.ENVIRONMENT,
            levelEnum.IMPROVEMENT,
            levelEnum.ISAFE,
            levelEnum.KONTRAKTOR,
            levelEnum.EXTERNAL,
          ],
        },
        */
        {
          id: 15,
          title: "Evaluasi PJP",
          iconActive: "window_check.png",
          iconInactive: "window_check.png",
          path: "#",
          subs: [
            {
              id: 1,
              title: "Dashboard",
              path: "/evaluation-dashboard",
              access: [
                levelEnum.ADMIN,
                levelEnum.OHS,
                levelEnum.ENVIRONMENT,
                levelEnum.IMPROVEMENT,
                levelEnum.ISAFE,
                levelEnum.REPORTER,
                levelEnum.KONTRAKTOR,
              ],
            },
            {
              id: 2,
              title: "Form Penilaian",
              path: "/evaluation-report",
              access: [
                levelEnum.ADMIN,
                levelEnum.OHS,
                levelEnum.ENVIRONMENT,
                levelEnum.IMPROVEMENT,
                levelEnum.ISAFE,
                levelEnum.REPORTER,
                levelEnum.KONTRAKTOR,
              ],
            },
            {
              id: 3,
              title: "Monitoring",
              path: "/evaluation-monitoring",
              access: [
                levelEnum.ADMIN,
                levelEnum.OHS,
                levelEnum.ENVIRONMENT,
                levelEnum.IMPROVEMENT,
                levelEnum.ISAFE,
                levelEnum.REPORTER,
                levelEnum.KONTRAKTOR,
              ],
            },
          ],
          showSub: false,
        },
        /*
        {
          id: 16,
          title: "SMKP BIB",
          iconActive: "window_check.png",
          iconInactive: "window_check.png",
          path: "#",
          subs: [
            {
              id: 1,
              title: "NC SMKP BIB",
              path: "/nc-smkp-report",
              access: [
                levelEnum.ADMIN,
                levelEnum.OHS,
                levelEnum.ENVIRONMENT,
                levelEnum.IMPROVEMENT,
                levelEnum.ISAFE,
                levelEnum.REPORTER,
              ],
            },
            {
              id: 2,
              title: "Monitoring NC",
              path: "/nc-smkp-monitoring",
              access: [levelEnum.ADMIN],
            },
            {
              id: 3,
              title: "Monitoring NC",
              path: "/nc-smkp-monitoring-audit",
              access: [
                levelEnum.OHS,
                levelEnum.ENVIRONMENT,
                levelEnum.IMPROVEMENT,
                levelEnum.ISAFE,
                levelEnum.REPORTER,
              ],
            },
          ],
          showSub: false,
        },
        {
          id: 17,
          title: "SMKP Mitra",
          iconActive: "window_check.png",
          iconInactive: "window_check.png",
          path: "#",
          subs: [
            {
              id: 1,
              title: "NC SMKP Mitra",
              path: "/nc-smkp-mitra-report",
              access: [
                levelEnum.ADMIN,
                levelEnum.OHS,
                levelEnum.ENVIRONMENT,
                levelEnum.IMPROVEMENT,
                levelEnum.ISAFE,
                levelEnum.REPORTER,
                levelEnum.KONTRAKTOR,
              ],
            },
            {
              id: 2,
              title: "Monitoring NC",
              path: "/nc-smkp-mitra-monitoring",
              access: [
                levelEnum.ADMIN,
                levelEnum.OHS,
                levelEnum.ENVIRONMENT,
                levelEnum.IMPROVEMENT,
                levelEnum.ISAFE,
                levelEnum.REPORTER,
              ],
            },
            {
              id: 3,
              title: "Monitoring NC",
              path: "/nc-smkp-mitra-monitoring-mitra",
              access: [levelEnum.KONTRAKTOR],
            },
          ],
          showSub: false,
        },
        */
        {
          id: 18,
          title: "ISO Internal",
          iconActive: "window_check.png",
          iconInactive: "window_check.png",
          path: "#",
          subs: [
            {
              id: 1,
              title: "NC Audit ISO & SMK3 (Internal)",
              path: "/nc-audit-iso-smk3-internal",
              access: [
                levelEnum.ADMIN,
                levelEnum.OHS,
                levelEnum.ENVIRONMENT,
                levelEnum.IMPROVEMENT,
                levelEnum.ISAFE,
                levelEnum.REPORTER,
              ],
            },
            {
              id: 2,
              title: "Monitoring NC",
              path: "/nc-audit-iso-smk3-internal-monitoring",
              access: [
                levelEnum.ADMIN,
                levelEnum.OHS,
                levelEnum.ENVIRONMENT,
                levelEnum.IMPROVEMENT,
                levelEnum.ISAFE,
                levelEnum.REPORTER,
              ],
            },
          ],
          showSub: false,
        },
        {
          id: 19,
          title: "ISO External",
          iconActive: "window_check.png",
          iconInactive: "window_check.png",
          path: "#",
          subs: [
            {
              id: 1,
              title: "NC Audit ISO & SMK3 (External)",
              path: "/nc-audit-iso-smk3-external",
              access: [levelEnum.ADMIN],
            },
            {
              id: 2,
              title: "Monitoring NC",
              path: "/nc-audit-iso-smk3-external-monitoring",
              access: [levelEnum.ADMIN, levelEnum.EXTERNAL],
            },
          ],
          showSub: false,
        },
      ],
    };
  },
  mounted() {
    this.role = this.resolveUserRole(this.userData.role);

    // tambahkan access untuk ISO External jika kontraktorName = "BORNEO INDOBARA"
    const menu19 = this.menus.find((menu) => menu.id === 19);
    if (
      menu19 &&
      menu19.subs &&
      this.userData.kontraktorName?.toUpperCase() === "BORNEO INDOBARA" &&
      Array.isArray(this.userData.role)
    ) {
      const sub1 = menu19.subs.find((sub) => sub.id === 1);
      if (sub1 && sub1.access) {
        sub1.access.push(this.role);
      }
    }

    this.menus = this.menus
      .map((item) => {
        if (item.access && item.access.includes(this.role)) {
          return item;
        }
        if (
          item.subs &&
          item.subs.length > 0 &&
          item.subs.some((sub) => sub.access.includes(this.role))
        ) {
          item.subs = item.subs
            .map((data) => {
              if (data.access.includes(this.role)) {
                return data;
              }
            })
            .filter((sub) => sub);
          return item;
        }
      })
      .filter((menu) => menu);
  },
  watch: {
    isMobile: {
      handler(newVal) {
        this.sidebarStore.setDrawer(!newVal);
      },
    },
  },
  created() {
    this.checkViewport();
    window.addEventListener("resize", this.checkViewport);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkViewport);
  },
  methods: {
    checkViewport() {
      this.isMobile = window.innerWidth < 1080;
    },
    isParentActive(routes) {
      return routes.some((route) => this.$route.path == route);
    },
    showSub(menu) {
      this.menus = this.menus.map((item) => {
        if (item.id === menu.id) {
          item.showSub = !item.showSub;
        } else {
          item.showSub = false;
        }
        return item;
      });
    },
  },
};
</script>

<style scoped>
@import url("./../assets/css/tailwind.css");

.sidebar {
  background-color: white;
  box-shadow: 2px 1px 6px rgba(0, 0, 0, 0.2);
}
</style>
